// For documentation on custom Ace editor modes, see:
// https://github.com/securingsincity/react-ace/blob/master/docs/FAQ.md#how-do-i-add-a-custom-mode

// @ts-expect-error
const SQLHighlightRules = window.ace.acequire('ace/mode/sql_highlight_rules').SqlHighlightRules;
// @ts-expect-error
const SQLMode = window.ace.acequire('ace/mode/sql').Mode;

export class ParameterizedSQLHighlightRules extends SQLHighlightRules {
  constructor() {
    super();
    // @ts-expect-error
    // The token is translated to .ace_custom_insights_sql_parameter by the ace editor
    // which has its styling defined in less/ace-editor.less
    this.$rules.start.unshift({token: 'custom_insights_sql_parameter', regex: '{{.*?}}'});
  }
}

export default class ParameterizedSQLMode extends SQLMode {
  constructor() {
    super();
    // @ts-expect-error
    this.HighlightRules = ParameterizedSQLHighlightRules;
  }
}
